import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { DataTableSelectOption } from '@/types';
    import DataTableSelect from '@/components/datatable/DataTableSelect.vue';
    import axios from 'axios';
    import { computed, ref } from 'vue';
    import { toast } from 'vue-sonner';
    import type { AcceptableValue } from 'reka-ui';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TableStatusSelect',
  props: {
    modelValue: {},
    onboardingStepId: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const emit = __emit;

    const currentValue = ref(props.modelValue);

    const options: DataTableSelectOption[] = [
        {
            value: 'completed',
            label: t('onboarding.statuses.completed'),
            color: 'green',
        },
        {
            value: 'rejected',
            label: t('onboarding.statuses.rejected'),
            color: 'red',
        },
        {
            value: 'pending',
            label: t('onboarding.statuses.pending'),
            color: 'transparent',
        },
    ];

    const handleStatusChange = async (newValue: AcceptableValue) => {
        const previousValue = currentValue.value;
        try {
            const selectedOption = options.find((opt) => opt.value === newValue);
            if (!selectedOption) return;
            currentValue.value = newValue;
            await axios.patch(
                route('v2.onboarding.update-status', {
                    companyOnboardingStep: props.onboardingStepId,
                }),
                {
                    status: newValue,
                },
            );
            emit('update:modelValue', newValue);
        } catch (error) {
            currentValue.value = previousValue;
            console.error('Failed to update status:', error);
            toast.error(t('onboarding.status_update_failed'));
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableSelect, {
    "model-value": currentValue.value,
    options: options,
    "onUpdate:modelValue": handleStatusChange
  }, null, 8, ["model-value"]))
}
}

})